import { render, staticRenderFns } from "./UserInfoDialog.vue?vue&type=template&id=4fe602a2&scoped=true"
import script from "./UserInfoDialog.vue?vue&type=script&lang=ts"
export * from "./UserInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserInfoDialog.vue?vue&type=style&index=0&id=4fe602a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe602a2",
  null
  
)

export default component.exports